(function ($) {
  holidayNavFormatterV1 = {
    formatter: $('.holiday-nav-formatter-v1 ')
  };

  Drupal.behaviors.holidayNavFormatterV1 = {
    get: function (key) {
      return holidayNavFormatterV1[key];
    },

    set: function (key, val) {
      holidayNavFormatterV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');
      var holidayCatMenus = formatter.find('.holiday-shop-prod-cat-v1').find('.cat-menu-wrapper');
      var menus = '';

      holidayCatMenus.each(function () {
        var thisMenu = $(this).find('.menu-text');
        var menu_text = thisMenu.text();
        var menu_hashtag = thisMenu.attr('data-hashtag');
        // NOTE: This JS will handle only only sub-menu. If you want to have multiple sub-sub-menus,change the code to recursive. This is designed to handle holiday 2015
        var myParent = $(this).find('.parent-text');

        if (myParent.length > 0) {
          var subMenus = '';
          var allMenus = holidayCatMenus.find('.menu-text').not('.processed');

          allMenus.each(function (i, e) {
            var item = $(e).next('.parent-text');

            if (item.length > 0) {
              if (myParent.first().text() == item.first().text()) {
                // Create li
                subMenus = subMenus + '<li class="menu-text-list"><a href="#" class="menu" data-hashtag="' + $(e).attr('data-hashtag') + '">' + $(e).text() + '</a></li>';
                $(e).addClass('processed');
              }
            }
          });
          if (subMenus != '') {
            menus = menus + '<li class="menu-text-list"><a href="#" class="menu parent">' + myParent.first().text() + '</a><ul class="child">' + subMenus + '</ul></li>';
          }
        } else {
          menus = menus + '<li class="menu-text-list"><a href="#" class="menu" data-hashtag="' + menu_hashtag + '">' + menu_text + '</a></li>';
        }

        thisMenu.addClass('processed');
      });

      var holidayNav = $('.holiday-nav-header ul.holiday-nav');

      holidayNav.append(menus);
      var holidayMenus = $('.holiday-nav-formatter-v1 .holiday-nav .menu');

      holidayMenus.on('click', function(e) {
        e.preventDefault();
        if ($(this).hasClass('parent')) {
          $(this).next('ul.child').slideToggle();
        } else {
          holidayMenus.removeClass('active');
          $('.holiday-nav-formatter-v1 .holiday-nav .more-content .menu').removeClass('active');
          $(this).addClass('active');
          var showProductsByCat = $(this).attr('data-hashtag');

          $('.holiday-shop-prod-cat-v1').hide();
          $('#' + showProductsByCat + '.holiday-shop-prod-cat-v1').show();
        }
      });

      var toogleHolidayMenu = function () {
        var hashValue = false;

        if (window.location.hash.length !== 0) {
          hashMenuValue = window.location.hash.substring(1);
          holidayHashMenu = holidayNav.find('.menu[data-hashtag="' + hashMenuValue + '"]');
          if (holidayHashMenu.length !== 0) {
            holidayHashMenu.trigger('click');
            hashValue = true;
          }
        }
        if (hashValue === false) {
          holidayMenus.first().trigger('click');
        }
      };

      toogleHolidayMenu();
      $(window).on('hashchange', function (e) {
        toogleHolidayMenu();
      });

      // The following creates a "More" menu when page is narrow
      $('#holiday-nav').append('<li class="item-more hidden"><span class="title"><a href="#">' + $('.mm-formatter-v1 .more-link').first().text() + ' <i class="icon-angle-down" /></a></span><div class="more-content"></div></li>');
      var menu = $('.holiday-nav-formatter-v1 .holiday-nav');
      var moreMenu = $('.item-more', menu);

      moreMenu.on('click', function(e) {
        e.preventDefault();
        var moreMenuContent = $('.more-content', moreMenu);

        moreMenuContent.slideToggle(600);
      });

      moreMenu.trigger('click');

      // give each menu item a width attribute to be used later
      $('li', menu).each(function () {
        var item = $(this);

        item.attr('width', parseInt(item.outerWidth(true)));
      });

      // dynamically populate the More menu
      var buildMoreHolidayMenu = function () {
        moreMenu.addClass('hidden');
        var moreMenuWidth = parseInt($('.holiday-nav').width()); // .outerWidth(true));
        var moreMenuContent = $('.more-content', moreMenu);
        var navs = $('.holiday-nav-formatter-v1 .holiday-nav li:visible').not('.item-more');
        var j = navs.length;

        for (var i = 0; i < j; i++) {
          var firstItemPos = $('li:first', menu),
            firstItemPos = firstItemPos.length ? firstItemPos.position().top : 0;
          var lastItemPos = $('li:visible:last', menu).not('.item-more'),
            lastItemPos = lastItemPos.length ? lastItemPos.position().top : 0;
          var lastElem = $('li:visible', menu).not('.item-more').last();

          // if a menu item breaks to the next line...
          if (lastItemPos > firstItemPos) {
            // hide the main menu item, and prepend a clone to the More menu
            lastElem.hide().clone(true).show().prependTo(moreMenuContent);
            j--;
          } else {
            if (i > 0) { // This is to move the "More" link in the same line
              lastElem.hide().clone(true).show().prependTo(moreMenuContent);
            }
            break;
          }
        }

        j = moreMenuContent.find('li').length;
        for (var i = 0; i < j; i++) {
          // replace hidden menu items if there is room, removing them from More menu
          var availableSpace = parseInt($('.holiday-nav-header').outerWidth(true)) - moreMenuWidth;
          var firstItemWidth = parseInt($('li:first', moreMenu).attr('width')) + 40;

          if (availableSpace > firstItemWidth) {
            // show the first-hidden menu item
            $('> li', menu).not(':visible').not('.item-more').first().show();
            // remove it from the More menu
            $('li:first', moreMenu).remove();
          } else {
            break;
          }
        }

        moreMenu.removeClass('hidden');
      };

      $(window).resize(function () {
        moreMenuLoad();
      });

      var moreMenuLoad = function () {
        buildMoreHolidayMenu();
        moreMenu.show();
        if ($('.holiday-nav .item-more .more-content').html().length <= 0) {
          moreMenu.hide();
        }
      };

      // Check the menus on page load
      moreMenuLoad();
    }
  };
})(jQuery);
